import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { Helper } from 'src/app/constants/helper';
import { OnlyOfficeConfig, UserEditConfig ,EditorType,HistoryData,ChangeHistory} from 'src/app/constants/only-office-config';
import { serviceConstants } from 'src/app/constants/service.constants';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { ReferencesDocumentsComponent } from '../my-reviews/references-documents/references-documents.component';
import { DeleteBoxComponent } from '../delete-box/delete-box.component';
import { ReviewService } from 'src/app/services/common/review.service';
import { LoaderService } from 'src/app/services/loader.service';
declare let DocsAPI: any;
@Component({
  selector: 'app-online-editor',
  templateUrl: './online-editor.component.html',
  styleUrls: ['./online-editor.component.scss']
})
export class OnlineEditorComponentimplements implements OnInit, OnDestroy {

  docEditor: any;
  showError = false;
  errorMsg = "";
  isAppReady = false;
  isDocumentReady = false;
  ReferanceDocuments: any = [];
  ReferanceDocumentsReq: boolean = false;
  PreviewReq: boolean = false;
  ReviewId: any;
  appCode: any;
  ReviewDocs: any=[];
  ApplicationCode: any;
  
  @Input() public Content: any;
  @Input() public config: Partial<UserEditConfig>;
  @Input() public editorType = EditorType.FreeEdit;
  @Input() public documentType: 'word' | 'cell' | 'slide';
  @Input() public formateType: string;
  formateTypeInput: string = "";
  
  private subKeepAlive: Subscription | null = null;

  constructor(
      private NgbModule: NgbActiveModal,
      private childModel: NgbModal,
      private commonService:CommonService,
      private userService:UserService,
      private administratorServices:AdministrationSummaryService,
      private modalService: NgbModal,
      private reviewService: ReviewService,
      private loaderService: LoaderService
  ) {
      this.formateTypeInput = this.formateType;
  }

  /**
  * Default configurations: User config is merged with this default config.
  */
  defaultConfig: OnlyOfficeConfig = {
      type: 'desktop',
      width: '100%',
      height: '100%',
      documentType: 'word',
      token: "",
      document: {
          title: 'Unknown document title',
          url: 'document url',
          fileType: 'docx',
          options: "",
          key: 'key',
          vkey: 'vkey',
          info: {
              owner: 'owner name',
              folder: 'path to document',
              uploaded: '<uploaded date>',
              sharingSettings: [
                  {
                      user: 'user name',
                      permissions: 'Full Access',
                      isLink: false
                  },
              ],
              favorite: undefined // true/false/undefined (undefined - don't show fav. button)
          },
          permissions: {
              edit: true, // default = true
              download: false, // default = true
              reader: true,
              review: true, // default = edit
              print: false, // default = true
              comment: true,// default = edit,
              modifyFilter: false, // default = true
              modifyContentControl: true,// default = true
              fillForms: false, // default = edit || review,
              copy: true, // default = true,
              editCommentAuthorOnly: true, // default = false
              deleteCommentAuthorOnly: true, // default = false,
              reviewGroups: ["Group1"], // current user can accept/reject review changes made by users from Group1 and users without a group. [] - use groups, but can't change any group's changes
              commentGroups: { // {} - use groups, but can't view/edit/delete any group's comments
                  view: ["Group1"], // current user can view comments made by users from Group1 and users without a group.
                  edit: ["Group1"],// current user can edit comments made by users from Group1 and users without a group.
                  remove: ["Group1"] // current user can remove comments made by users from Group1 and users without a group.
              },
              userInfoGroups: ["Group1"],// show tooltips/cursors/info in header only for users in userInfoGroups groups. [""] - means users without group, [] - don't show any users, null/undefined/"" - show all users
              protect: false, // default = true. show/hide protect tab or protect buttons
          }
      },
      editorConfig: {
          mode: 'edit',
          lang: "en",
          location: "us",
          canCoAuthoring: true,
          canBackToFolder: false,
          createUrl: '',
          sharingSettingsUrl: '',
          fileChoiceUrl: '', // for mail merge or image from storage
          callbackUrl: "",
          saveAsUrl: '',
          licenseUrl: '',
          customerId: '',
          region: 'en-us', // can be 'en-us' or lang code
          user: {
              id: 'user id',
              name: 'user name',
              group: 'group name' // for customization.reviewPermissions or permissions.reviewGroups or permissions.commentGroups. Can be multiple groups separated by commas (,) : 'Group1' or 'Group1,Group2'
          },
          recent: [
              {
                  title: 'document title',
                  url: 'document url',
                  folder: 'path to document',
              }
          ],
          embedded: {
              toolbarDocked: "top",
          },
          templates: [
              {
                  image: 'template icon url',
                  url: ''
              },
          ],
          customization: {
              logo: {
                  image: '',
                  imageDark: '', // logo for dark theme
                  url: ''
              },
              customer: {
                  name: 'Scimax Global LLC',
                  address: '',
                  mail: 'support@scimaxglobal.com',
                  www: 'www.scimaxglobal.com',
                  phone: '',
                  info: '',
                  logo: 'https://www.scimaxglobal.com/wp-content/uploads/2022/04/scimax-logo-blue.png',
                  logoDark: 'https://www.scimaxglobal.com/wp-content/uploads/2022/04/scimax-logo-blue.png', // logo for dark theme
              },
              about: false,
              feedback: {
                  visible: false,
                  url: ''
              },
              goback: {
                  url: '',
                  text: '',
                  blank: true,
                  requestClose: false // if true - goback send onRequestClose event instead opening url
              },
              reviewPermissions: {

              },
              anonymous: { // set name for anonymous user
                  request: true, // enable set name
                  label: "Guest" // postfix for user name
              },
              review: {
                  hideReviewDisplay: false, // hide button Review mode
                  hoverMode: true, // true - show review balloons on mouse move, not on click on text
                  showReviewChanges: true,
                  reviewDisplay: 'markup', // original for viewer, markup for editor
                  trackChanges: true // true/false - open editor with track changes mode on/off, owner false,only review true rest all false
              },
              layout: { // hide elements, but don't disable feature
                  toolbar: {
                      file: { // menu file
                          close: false, // close menu button
                          settings: true, // advanced settings
                          info: false, // document info
                          save: true // save button
                      },
                      home: {
                          mailmerge: false, // mail merge button
                      },
                      layout: true, // layout tab
                      references: true, // de references tab
                      collaboration: true, // collaboration tab
                      protect: false, // protect tab
                      plugins: true, // plugins tab
                      view: {
                          navigation: true // navigation button in de
                      }, // view tab
                      save: true, // save button on toolbar in 
                  }, // use instead of customization.toolbar,
                  header: {
                      users: true, // users list button
                      save: true // save button
                  },
                  leftMenu: {
                      navigation: true,
                      spellcheck: true // spellcheck button in sse
                  }, // use instead of customization.leftMenu
                  rightMenu: false, // use instead of customization.rightMenu
                  statusBar: {
                      textLang: true, // text language button in de/pe
                      docLang: true, // document language button in de/pe
                      actionStatus: true, // status of operation
                  }, // use instead of customization.statusBar
              },
              features: { // disable feature
                  spellcheck: {
                      mode: true, // init value in de/pe
                      change: true, // hide/show feature in de/pe/sse
                  }, // if false/true - use as init value in de/pe. use instead of customization.spellcheck parameter
              },
              chat: true,
              comments: true,
              zoom: -2,
              compactToolbar: false,
              hideRightMenu: true, // hide or show right panel on first loading
              autosave: true,
              forcesave: false,
              help: true,
              compactHeader: false,
              toolbarNoTabs: false,
              toolbarHideFileName: false,
              compatibleFeatures: false,
              unit: 'cm', // cm, pt, inch,
              mentionShare: true, // customize tooltip for mention,
              macros: true, // can run macros in document
              plugins: true, // can run plugins in document
              macrosMode: 'warn', // warn about automatic macros, 'enable', 'disable', 'warn',
              hideRulers: false, // hide or show rulers on first loading (presentation or document editor)
              hideNotes: false, // hide or show notes panel on first loading (presentation editor)
              uiTheme: 'default-light', // set interface theme: id or default-dark/default-light
              integrationMode: "embed", // turn off scroll to frame
          },
          coEditing: {
              mode: 'fast', // <coauthoring mode>, 'fast' or 'strict'. if 'fast' and 'customization.autosave'=false -> set 'customization.autosave'=true. 'fast' - default for editor
              // for viewer: 'strict' is default, offline viewer; 'fast' - live viewer, show changes from other users
              change: false, // can change co-authoring mode. true - default for editor, false - default for viewer
          },

          wopi: { // only for wopi
              FileNameMaxLength: 250 // max filename length for rename, 250 by default
          }
      },
      events: {
          onAppReady: this.onAppReady,
          onDocumentReady: this.onDocumentReady,
          onDocumentStateChange: this.onDocumentStateChange,
          onError: this.onError,
          onOutdatedVersion: this.onOutdatedVersion, //<outdated version callback>,// send when  previous version is opened
          // 'onRequestEditRights': <request rights for switching from view to edit>,
          // 'onRequestHistory': <request version history>,// must call refreshHistory method
          // 'onRequestHistoryData': <request version data>,// must call setHistoryData method
          // 'onRequestRestore': <try to restore selected version>,
          // 'onRequestHistoryClose': <request closing history>,
          // 'onWarning': <warning callback>,
          // 'onInfo': <document open callback>,// send view or edit mode
          // 'onDownloadAs': <download as callback>,// send url of downloaded file as a response for downloadAs method
          // 'onRequestSaveAs': <try to save copy of the document>,
          // 'onCollaborativeChanges': <co-editing changes callback>,// send when other user co-edit document
          // 'onRequestRename': <try to rename document>,
          // 'onMetaChange': // send when meta information changed
          // 'onRequestClose': <request close editor>,
          // 'onMakeActionLink': <request link to document with bookmark, comment...>,// must call setActionLink method
          // 'onRequestUsers': <request users list for mentions>,// must call setUsers method
          // 'onRequestSendNotify': //send when user is mentioned in a comment,
          // 'onRequestInsertImage': <try to insert image>,// must call insertImage method
          // 'onRequestCompareFile': <request file to compare>,// must call setRevisedFile method
          // 'onRequestSharingSettings': <request sharing settings>,// must call setSharingSettings method
          // 'onRequestCreateNew': <try to create document>,
      }
  }

  ngOnInit() {
      if (this.config !== null && this.config !== undefined && this.config.TempFileID !== "") {
          try {
              let isWoner = false;
              let CurrentUserID = this.config.UserID ?? "";
              let GroupsList: any = [];
              let loggedUserID = this.userService.getUserID();
              if(this.Content.ReviewDocs != null)
              {
                this.ReviewDocs = this.Content.ReviewDocs;
              }
             
              if(this.Content.allFiles != null)
              {
                this.ReviewDocs = this.Content.allFiles;
              }

              this.ApplicationCode = this.Content.ApplicationCode;
              if (this.config.OwnerID == loggedUserID) {
                  isWoner = true;
                  CurrentUserID = this.config.OwnerID;
              }
              const docConfig: Partial<OnlyOfficeConfig> = {
                  documentType: this.documentType,
                  document: {
                      title: this.config.FileName ?? 'Unknown document title',
                      url: serviceConstants.apiURL + 'api/Login/GetStream?fileID=' + this.config.TempFileID,
                      fileType: this.config.FileType,
                      key: this.config.UniKey,
                      vkey: this.config.UniKey,
                      info: {
                          owner: this.config.OwnerName ?? "",
                          uploaded: new Date().getDate().toString(),
                      },
                      permissions: {
                          protect: false,
                          edit: this.config.CanEdit, // default = true
                          review: this.config.CanReview, // default = edit
                          reviewGroups: [GroupsList], // current user can accept/reject review changes made by users from Group1 and users without a group. [] - use groups, but can't change any group's changes
                          commentGroups: { // {} - use groups, but can't view/edit/delete any group's comments
                              view: [GroupsList], // current user can view comments made by users from Group1 and users without a group.
                              edit: [GroupsList],// current user can edit comments made by users from Group1 and users without a group.
                              remove: [GroupsList] // current user can remove comments made by users from Group1 and users without a group.
                          },
                          userInfoGroups: [GroupsList],// show tooltips/cursors/info in header only for users in userInfoGroups groups. [""] - means users without group, [] - don't show any users, null/undefined/"" - show all users
                          editCommentAuthorOnly: isWoner ? false : true,
                          deleteCommentAuthorOnly: isWoner ? false : true
                      },
                      options: "",
                  },

                  editorConfig: {
                      mode: this.config.IsEditMode ? "edit" : "view",
                      callbackUrl: serviceConstants.apiURL + 'oo.ashx?type=track&etype=' + this.editorType + '&configID=' + this.config.UserConfigID + '&loggedUserID=' + loggedUserID,
                      user: {
                          id: CurrentUserID,
                          name: this.config.UserName,
                          group: '', // for customization.reviewPermissions or permissions.reviewGroups or permissions.commentGroups. Can be multiple groups separated by commas (,) : 'Group1' or 'Group1,Group2'
                      },
                      customization: {
                          logo: {
                              image: document.location.origin + "/assets/images/OOlogg.png",
                              imageDark: document.location.origin + "/assets/images/OOlogg.png", // logo for dark theme
                              url: null,
                          },
                          reviewPermissions: {
                              CurrentUserID: [GroupsList],
                          },
                          review: {
                              showReviewChanges: (isWoner ? true : false),
                              trackChanges: (isWoner ? false : this.config.CanReview ?? false),
                              hideReviewDisplay: false,
                              hoverMode: true, // true - show review balloons on mouse move, not on click on text
                              reviewDisplay: 'markup', // original for viewer, markup for editor
                          },
                          compatibleFeatures: false,
                          unit: 'cm', // cm, pt, inch,
                          layout: { // hide elements, but don't disable feature
                              toolbar: {
                                  file: { // menu file
                                      close: false, // close menu button
                                      settings: true, // advanced settings
                                      info: false, // document info
                                      save: true // save button
                                  },
                                  home: {
                                      mailmerge: false, // mail merge button
                                  },
                                  layout: true, // layout tab
                                  references: true, // de references tab
                                  collaboration: true, // collaboration tab
                                  protect: false, // protect tab
                                  plugins: true, // plugins tab
                                  view: {
                                      navigation: true // navigation button in de
                                  }, // view tab
                                  save: true, // save button on toolbar in 
                              }, // use instead of customization.toolbar,
                              header: {
                                  users: true, // users list button
                                  save: true // save button
                              },
                              leftMenu: {
                                  navigation: true,
                                  spellcheck: true // spellcheck button in sse
                              }, // use instead of customization.leftMenu
                              rightMenu: true, // use instead of customization.rightMenu
                              statusBar: {
                                  textLang: true, // text language button in de/pe
                                  docLang: true, // document language button in de/pe
                                  actionStatus: true, // status of operation
                              }, // use instead of customization.statusBar
                          },
                          features: { // disable feature
                              spellcheck: {
                                  mode: true, // init value in de/pe
                                  change: true, // hide/show feature in de/pe/sse
                              }, // if false/true - use as init value in de/pe. use instead of customization.spellcheck parameter
                          },
                          macrosMode: 'warn', // warn about automatic macros, 'enable', 'disable', 'warn',
                          anonymous: { // set name for anonymous user
                              request: true, // enable set name
                              label: "Guest" // postfix for user name
                          },
                          integrationMode: "embed",
                      },
                      canBackToFolder: false,
                      customerId: '',
                      licenseUrl: '',
                      region: 'en-us',
                      wopi: { // only for wopi
                          FileNameMaxLength: 250 // max filename length for rename, 250 by default
                      },
                      coEditing: {
                          mode: 'fast', // <coauthoring mode>, 'fast' or 'strict'. if 'fast' and 'customization.autosave'=false -> set 'customization.autosave'=true. 'fast' - default for editor
                          // for viewer: 'strict' is default, offline viewer; 'fast' - live viewer, show changes from other users
                          change: false, // can change co-authoring mode. true - default for editor, false - default for viewer
                      },
                  }
              };

             // this.subKeepAlive = this.commonService.keepAliveSession$.subscribe();
              let finalConfig = Helper.extend(this.defaultConfig, docConfig);
              this.GetOnlyOfficeToken(finalConfig).subscribe((result) => {
                  finalConfig.token = result.token;
                  this.docEditor = DocsAPI.DocEditor("docLaunchpad", finalConfig);
              });

          } catch (e) {
              console.error("Issue at OnlineEditorComponent.ngOnInit(), Block 1:\n" + e);
          }
      }
  }

  GetOnlyOfficeToken(docConfig: any) {
      let formData = new Object();
      formData["Config"] = JSON.stringify(docConfig);
      return this.administratorServices.PostData("api/Review/GetOnlyofficeToken", formData);
  }

  EditorPopupClose() {       
    this.loaderService.isLoading.next(true);
    setTimeout(() => {
        this.destroyEditor(); 
        this.loaderService.isLoading.next(false);
        this.closeEditorPopup("close");
    }, 5000);   
  }

  closeEditorPopup(ClosedFrom) {
      this.NgbModule.close(ClosedFrom);
  }

    CompleteDocs() {     
            if (this.config.OwnerID==this.config.UserID) {
                this.ReviewId=this.Content.ReviwID;
             this.TaskComplete(this.Content.FileID);
            }
            else {
                let updateDocs = this.ReviewDocs.find(y=>y.FileID == this.Content.FileID);
                let modalRefe = this.modalService.open(DeleteBoxComponent, { backdrop: false });
                modalRefe.componentInstance.Content = { heading: 'Confirmation', custommessage: 'You are about to complete the Review for ' + updateDocs.FileName + '; do you want to proceed?', ProceedButtonName: "Confirm", TerminateButtonName: "Cancel" };
                modalRefe.result.then(result => {
                  if (result == "okclick") {
                    let formData = { "ReviewId":this.Content.ReviwID ,"ReviewDocId": updateDocs.FileID, "ApplicationCode": this.ApplicationCode, DocStatus: updateDocs.Status };
                    this.loaderService.isLoading.next(true); 
                    setTimeout(() => {
                        this.loaderService.isLoading.next(false);    
                    this.reviewService.UpdateDocReviewerStatus("api/Review/CompleteDocumentReview", formData).subscribe(result=>{
                        this.NgbModule.close("complete");
                     });
                    }, 5000); 
                  }
                });
            } 
      
    }
    TaskComplete(DocId: any) {
        this.reviewService.CheckIsLastTaskComplete("api/Review/CheckIsLastTaskComplete?ReviewId=" + this.ReviewId + "&DocId=" + DocId).subscribe(result => {
            if (result["Status"] != 1) {
            this.appCode = result["Data"].Application_Code;
            const modalRef = this.modalService.open(DeleteBoxComponent, { backdrop: false })
            modalRef.componentInstance.Content = { heading: 'Confirmation', custommessage: 'You are about to complete the Review for document ' + this.config.FileName + '; do you want to proceed?', ProceedButtonName: "Confirm", TerminateButtonName: "Cancel" }
            modalRef.result.then((result1) => {
              if (result1 == "okclick") {
                this.loaderService.isLoading.next(true); 
                setTimeout(() => {
                    this.loaderService.isLoading.next(false); 
               
                this.UpdateDocumentStatus(DocId, result["Data"].ReviewTitle, result["Status"]);
                }, 5000); 
              }
            });
          }
        });
      }
      UpdateDocumentStatus(DocId: any, reviewtitle: any, IsLast: any) {
        if (IsLast == 2) {
          const modalRef = this.modalService.open(DeleteBoxComponent, { backdrop: false })
          modalRef.componentInstance.Content = { heading: 'Confirmation', custommessage: 'You are about to Close the Review ' + reviewtitle + '; do you want to proceed?', ProceedButtonName: "Confirm", TerminateButtonName: "Cancel" }
          modalRef.result.then((result) => {
            if (result == "okclick") {
              this.UpdateDocument_ReviewStatus(DocId);
            }
          });
        }
        else {
          let formData = { "ReviewId":this.ReviewId ,"ReviewDocId": DocId ,"ApplicationCode":this.appCode 
            };     
            this.reviewService.UpdateDocumentStatus("api/Review/UpdateDocumentStatus", formData).subscribe(res => {
            if (res.Status == 0) {       
                this.commonService.SuccessBanner(res.Message);
                this.NgbModule.close();
            }
            else{
              this.commonService.ValidationBanner(res.Message);
            }    
          }); 
        }
      }
    
      UpdateDocument_ReviewStatus(DocId: any) {
        let formData = { "ReviewId":this.ReviewId ,"ReviewDocId": DocId ,"ApplicationCode":this.appCode 
      };     
      this.reviewService.UpdateDocument_ReviewStatus("api/Review/UpdateDocument_ReviewStatus", formData).subscribe(result => {
      if (result.Status == 0) {       
          this.commonService.SuccessBanner(result.Message);
          this.NgbModule.close();
      }
      else{
        this.commonService.ValidationBanner(result.Message);
      }    
    }); 
    }

  openReferenceDocs() {
    let modalRef = this.modalService.open(ReferencesDocumentsComponent, {
        backdrop: false,
        keyboard: false,
        windowClass: 'modal-vlg right modal-right',
        animation: true
      });
      modalRef.componentInstance.Content= {
        heading: 'Reference Documents',
        content: { ReviewId:this.Content.ReviwID}
      }
      modalRef.result.then(result => {    
      });
  }


  /**
   * Deny editing:
   * This method can be called when you want to make the document editing unavailable.
   * @param message Defines the text messages for dialog.
   */
  denyEditingRights(message?: string): void {
      if (this.docEditor) {
          this.docEditor.denyEditingRights(message);
      }
  }

  /**
   * Destroy docEditor object.
   * This method can be called when you want to reinit document editor with another configurations or close editing.
   * Used since version 4.3.
   * */
  destroyEditor(): void {
      if (this.docEditor) {
          this.docEditor.destroyEditor();
      }
      if (this.subKeepAlive) {
          this.subKeepAlive.unsubscribe();
      }
  }

  /**
   * Download the edited file.
   * This method can be called only when the existence of the onDownloadAs events.
   * Document editing service asynchronously creates a document
   * and triggers the onDownloadAs event with a link in parameter.
   * */
  downloadAs() {
      if (this.docEditor) {
          this.docEditor.downloadAs();
      }
  }

  /**
   * Display tooltip with the message.
   * This method can be called only after the onAppReady events.
   * @param message
   */
  showMessage(message: string) {
      if (this.isAppReady && this.docEditor)
          this.commonService.ValidationBanner(message);
  }

  /**
   * The function called when the application is loaded into the browser.
   */
  onAppReady() {
      this.isAppReady = true;
      console.trace("Online Document Editor is ready");
  }

  /**
   * The function called when the document is co-edited by the other user in the strict co-editing mode.
   */
  onCollaborativeChanges() {
      console.trace("The document changed by collaborative user");
  }

  /**
   * The function called when the document is loaded into the document editor.
   */
  onDocumentReady() {
      this.isDocumentReady = true;
      console.trace("Document is loaded");

      try { window.frames[0].document.querySelector<HTMLElement>("li.ribtab>a[data-tab='file']")!.parentElement!.style.display = "none"; }
      catch (e) { console.error('Error in onDocumentReady Block 1:\n' + e); }

      try { window.frames[0].document.querySelector<HTMLElement>("div#header-logo")!.style.backgroundColor = 'white'; }
      catch (e) { console.error('Error in onDocumentReady Block 2:\n' + e); }

      try { window.frames[0].document.querySelector<HTMLElement>("button#left-btn-about")!.style.display = "none"; }
      catch (e) { console.error('Error in onDocumentReady Block 3:\n' + e); }

      try { window.frames[0].document.querySelector<HTMLElement>("a#asc-gen237")!.parentElement!.style.display = "none"; }
      catch (e) { console.error('Error in onDocumentReady Block 4:\n' + e); }

      try { window.frames[0].document.querySelector<HTMLElement>("button#asc-gen316")!.parentElement!.style.display = "none"; }
      catch (e) { console.error('Error in onDocumentReady Block 5:\n' + e); }

      try { window.frames[0].document.querySelector<HTMLElement>("div#developer-hint")!.style.display = "none"; }
      catch (e) { console.error('Error in onDocumentReady Block 6:\n' + e); }
  }

  /**
   * The function called when the document is modified.
   * It is called with the parameter: {"data": true} when the current user is editing the document and
   * with the parameter: {"data" : false} when the current user's changes are sent to the document editing service.
   * @param event event object returned by the document server.
   */
  onDocumentStateChange(event: any): void {
      if (event.data) {
          console.trace("The document changed");
      } else {
          console.trace("Changes are collected on document editing service");
      }
  }

  /**
   * The function called with the absolute URL to the edited file when the downloadAs method is being called.
   * The absolute URL to the document to be downloaded is sent in the data parameter.
   * @param event event object returned by the document server.
   */
  onDownloadAs(event: any): void {
      if (event) {
          console.trace("Online Document Editor create file: " + event.data);
      }
  }

  /**
   * The function called when an error or some other specific event occurs.
   * The error message is sent in the data parameter.
   * @param event event object returned by the document server.
   */
  onError(event: any): void {
      if (event) {
          console.trace(event);
      }
  }

  /**
   * The function called when the application opened the file.
   * The mode is sent in the data.mode parameter. Can be view or edit.
   * @param event event object returned by the document server.
   */
  onInfo(event: any) {
      if (event) {
          console.info("Online Document Editor is opened in " + event.data.mode + " mode.");
      }
  }

  /**
   * The function called when the user is trying to open the document which contains a bookmark, scrolling to the bookmark position.
   * To use the document bookmarks you must call the setActionLink method.
   * The bookmark data is received in the event.data parameter.
   * @param event event object returned by the document server.
   */
  onMakeActionLink(event: any) {
      if (event) {
          const ACTION_DATA = event.data;
          console.trace(ACTION_DATA);
      }
  }

  /**
   * The function called after the error is shown, when the document is opened for editing with the old document.key value,
   * which was used to edit the previous document version and was successfully saved.
   * When this event is called the editor must be reinitialized with a new document.key.
   */
  onOutdatedVersion() {
      location.reload();
  }

  /**
   * The function called when the work with the editor must be ended and the editor must be closed.
   */
  onRequestClose() {
      if (window.opener) {
          window.close();
          return;
      }
      if (this.docEditor) {
          this.docEditor.destroyEditor();
      }
  }

  /**
   * The function called when the user is trying to switch the document from the viewing into the editing mode by clicking the Edit Document button.
   * When the function is called, the editor must be initialized again, in editing mode.
   * If the method is not declared the Edit button will not be displayed.
   */
  onRequestEditRights() {
      document.location.reload();
  }

  /**
   * The function called when the user is trying to show the document version history by clicking the Version History button.
   * To show the document version history you must call the refreshHistory method.
   */
  onRequestHistory() {
      const changeHistory: ChangeHistory = {};
      this.docEditor.refreshHistory(changeHistory);
  }

  /**
   * The function called when the user is trying to go back to the document from viewing the document version history by clicking the Back to Document button.
   * When the function is called, the editor must be initialized again, in editing mode.
   * If the method is not declared the Back to Document button will not be displayed.
   */
  onRequestHistoryClose() {
      document.location.reload();
  }

  /**
   * The function called when the user is trying to click the specific document version in the document version history.
   * To show the changes corresponding to the specific document version you must call the setHistoryData method.
   * The document version number is sent in the data parameter.
   * @param event event object returned by the document server.
   */
  onRequestHistoryData(event: any) {
      if (event) {
          const version = event.data;
          const historyData: HistoryData = { version };
          this.docEditor.setHistoryData(historyData);
      }
  }

  /**
   * The function is called when an warning occurs.
   * The warning message is sent in the data parameter.
   * @param event event object returned by the document server.
   */
  onWarning(event: any) {
      if (event) {
          const warning = "Online Document Editor reports a warning: code " + event.data.warningCode + ", description " + event.data.warningDescription;
          window.alert(warning);
      }
  }

  ngOnDestroy(): void {
      if (this.subKeepAlive) {
          this.subKeepAlive.unsubscribe();
      }
      // if(this.subGetDataByID) this.subGetDataByID.unsubscribe();
      // if(this.subInsertDataPost) this.subInsertDataPost.unsubscribe();
      // if(this.subInsertDataPost1) this.subInsertDataPost1.unsubscribe();
  }
}

